import { createBrowserHistory } from 'history'
export { default as AuthenticatedRoute } from './AuthenticatedRoute'
export { default as GuestRoute } from './GuestRoute'

let history = createBrowserHistory()
export default history
